import { Container, Graphics, Sprite } from 'pixi.js';
import { IImage, IRoomSprite } from 'src/sync/_api';
import { RoomSprite } from './room-sprite';
import { Room } from 'src/sync/room';
import { Store } from 'src/sync/store';
import { View } from './view';
import { Settings } from './settings';
import { Account } from 'src/sync/account';

export class Image extends RoomSprite {
    public override type: 'token' | 'image' = 'image';
    public border!: Graphics;
    public width: number = 0;
    public height: number = 0;

    constructor(public override data: IImage, public override sprite: Sprite, private container: Container) {
        super(data as IRoomSprite, sprite);
        // TODO: Standardize left click event for RoomSprite
        sprite.on('pointerdown', (e) => {
            if (e.button == 0) {
                // NB setTimeout necessary to let Mouse.ts pointerdown fire before this
                setTimeout(() => this.select(true));
            }
        });
        this.width = sprite.width;
        this.height = sprite.height;
        this.border = this.container.addChild(new Graphics());
        this.redraw();
    }

    public override select(activate: boolean) {
        this.data.selectorId = Account.id;
        super.select(activate);
        this.redraw();
    }

    public override deselect() {
        this.data.selectorId = undefined;
        super.deselect();
        this.border.clear();
    }

    public redraw() {
        const scale = Settings.gridOffset / this.data.gridScale;
        this.sprite.width = this.width * scale;
        this.sprite.height = this.height * scale;

        if (Store.activeSprite.value?.data.id != this.data.id) return;

        this.border.position.copyFrom(this.data.position);
        const borderWidth = 4 * (1 / View.viewport.scale.x);
        this.border.clear().rect(0, 0, this.sprite.width, this.sprite.height).stroke({ color: 'blue', width: borderWidth, alignment: 0 })
    }

    public emitChanges() {
        Room.images.set(this.data.id, this.data);
    }

    public clone() {
        // TODO: Implement image cloning
    }

    public override destroy() {
        this.border.clear();
        super.destroy();
    }
}
